export default {
  'pages.covenantDevice.mac': 'MAC Address',
  'pages.admin.providerCard.config.grpcAddr': 'gRPC Address',
  'pages.covenantDevice.cardTitle': 'Covenant Device Management',
  'pages.admin.whitelist.mac': 'MAC Address',
  'pages.covenantDevice.operations': 'Operations',
  'pages.covenantDevice.expireTime': 'Expiration Time',
  'pages.covenantDevice.updateTime': 'Update Time',
  'pages.admin.ops.logViewer.previewTitle': 'Log Preview',
  'pages.admin.ops.logViewer.fileName': 'File Name:',
  'pages.admin.ops.logViewer.lineCount': 'Lines:',
  'pages.admin.ops.logViewer.previewBtn': 'Preview',
  'pages.admin.ops.logViewer.noContent': 'No content',
  'pages.unbindDevice.titleAdmin': 'Unbind Device (Admin Required)',
  'pages.unbindDevice.inputPlaceholder': 'Please enter device ID',
  'pages.unbindDevice.unbind': 'Unbind',
  'pages.unbindDevice.unbinding': 'Unbinding...',
  'pages.unbindDevice.success': 'Unbind successful',
  'pages.unbindDevice.fail': 'Unbind failed',
  'pages.layouts.userLayout.title': 'Management Console',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage': 'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',

  // Agents page related text
  'pages.agents.search.placeholder': 'Search agents',
  'pages.agents.create.button': 'Create Agent',
  'pages.agents.addDevice.button': 'Add Device',
  'pages.agents.create.modal.title': 'Create Agent',
  'pages.agents.create.modal.nameLabel': 'Agent Name',
  'pages.agents.create.modal.placeholder': 'Please enter agent name',
  'pages.agents.card.id': 'ID',
  'pages.agents.card.voiceModel': 'Voice Model',
  'pages.agents.card.languageModel': 'Language Model',
  'pages.agents.card.lastChat': 'Last Chat',
  'pages.agents.card.conversationId': 'Conversation ID',
  'pages.agents.card.clearConversation': 'Clear Conversation ID',
  'pages.agents.card.clearConversation.success': 'Conversation ID cleared',
  'pages.agents.card.clearConversation.error': 'Failed to clear conversation ID',
  'pages.agents.card.configRole': 'Configure Role',
  'pages.agents.card.voiceRecognition': 'Voice Recognition',
  'pages.agents.card.voiceRecognition.developing': 'Feature under development, please stay tuned',
  'pages.agents.card.historyDialog': 'History Dialog',
  'pages.agents.card.manageDevice': 'Manage Devices',
  'pages.agents.card.addDevice': 'Add Device',
  'pages.agents.loading': 'Loading agent list...',
  'pages.agents.reload': 'Reload',
  'pages.agents.empty.title': 'No agents available',
  'pages.agents.empty.createFirst': 'Create your first agent',
  'pages.agents.delete.title': 'Confirm Delete Agent',
  'pages.agents.delete.content': 'After deleting the agent, all related configurations (including device-related conversation records) cannot be recovered. Are you sure you want to delete?',
  'pages.agents.delete.confirm': 'Confirm Delete',
  'pages.agents.fetch.error': 'Failed to fetch agent list',
  'pages.agents.network.error': 'Network error, please try again later',
  'pages.agents.speed.patient': 'Patient',
  'pages.agents.speed.normal': 'Normal',
  'pages.agents.speed.fast': 'Fast',
  'pages.agents.lastChat.none': 'None',
  'pages.agents.language.chinese': 'Chinese',
  'pages.agents.loading.tts.error': 'Failed to load TTS voices',
  'pages.agents.loading.llm.error': 'Failed to load LLM providers',
  'pages.agents.sort.id': 'Sort by ID',
  'pages.agents.sort.updatedAt': 'Sort by last modified',
  'pages.agents.sort.lastConversationAt': 'Sort by last conversation',

  // Register page related text
  'pages.register': 'Register',
  'pages.register.title': 'Register',
  'pages.register.form.title': 'Register New Account',
  'pages.register.submit': 'Register',
  'pages.register.username.placeholder': 'Please enter username',
  'pages.register.username.required': 'Please enter username!',
  'pages.register.username.min': 'Username must be at least 4 characters',
  'pages.register.email.placeholder': 'Please enter email',
  'pages.register.email.required': 'Please enter email!',
  'pages.register.email.invalid': 'Please enter a valid email address!',
  'pages.register.password.placeholder': 'Please enter password',
  'pages.register.password.required': 'Please enter password!',
  'pages.register.password.min': 'Password must be at least 6 characters',
  'pages.register.password.pattern': 'Password must contain uppercase, lowercase letters and numbers',
  'pages.register.confirmPassword.placeholder': 'Please confirm password',
  'pages.register.confirmPassword.required': 'Please confirm password!',
  'pages.register.confirmPassword.min': 'Password must be at least 6 characters',
  'pages.register.error.passwordMismatch': 'The two passwords do not match',
  'pages.register.error.registerFailed': 'Registration failed, please try again!',
  'pages.register.success': 'Registration successful!',

  // Login page related text
  'pages.login.title': 'Anime AI Chat Management Console',
  'pages.login.actionIcons.notImplemented': 'Not implemented yet, coming soon',
  'pages.login.mobile.captchaError': 'Verification code error',
  'pages.login.captcha.success': 'Verification code sent successfully! Code: 1234',
  'pages.login.forgotPassword.contactAdmin': 'Please contact administrator',
  'pages.login.mobile.notAvailable': 'This feature is not available yet, please use account login',

  // AgentSetting page related text
  'pages.agentSetting.title': 'Configure Role',
  'pages.agentSetting.back': 'Back',
  'pages.agentSetting.roleTemplate.title': 'Role Template',
  'pages.agentSetting.roleTemplate.label': 'Template',
  'pages.agentSetting.template.taiwanGirlfriend': 'Taiwan Girlfriend',
  'pages.agentSetting.template.potato': 'Potato',
  'pages.agentSetting.template.englishTutor': 'English Tutor',
  'pages.agentSetting.template.curiousBoy': 'Curious Boy',
  'pages.agentSetting.template.puppyLeader': 'Puppy Leader',
  'pages.agentSetting.basicConfig.title': 'Basic Configuration',
  'pages.agentSetting.assistantName.label': 'Assistant Name',
  'pages.agentSetting.assistantName.placeholder': 'Please enter assistant name',
  'pages.agentSetting.assistantName.required': 'Please enter assistant name',
  'pages.agentSetting.dialogLanguage.label': 'Dialog Language',
  'pages.agentSetting.dialogLanguage.placeholder': 'Select dialog language',
  'pages.agentSetting.voiceType.label': 'Voice Type',
  'pages.agentSetting.voiceType.placeholder': 'Select voice type',
  'pages.agentSetting.roleDescription.title': 'Role Description',
  'pages.agentSetting.roleDescription.label': 'Role Description',
  'pages.agentSetting.roleDescription.placeholder': 'Please enter role description',
  'pages.agentSetting.roleDescription.required': 'Please enter role description',
  'pages.agentSetting.languageModel.title': 'Language Model',
  'pages.agentSetting.languageModel.label': 'Language Model',
  'pages.agentSetting.languageModel.placeholder': 'Select language model',
  'pages.agentSetting.languageModel.tip': 'After changing the model, it is recommended to clear the memory to avoid affecting the chat experience.',
  'pages.agentSetting.advancedSettings.expand': 'Expand Advanced Settings',
  'pages.agentSetting.advancedSettings.collapse': 'Collapse Advanced Settings',
  'pages.agentSetting.recognitionSpeed.label': 'Speech Recognition Speed',
  'pages.agentSetting.recognitionSpeed.placeholder': 'Select recognition speed',
  'pages.agentSetting.speechSpeed.label': 'Speech Speed',
  'pages.agentSetting.speechSpeed.placeholder': 'Select speech speed',
  'pages.agentSetting.pitchValue.label': 'Character Volume',
  'pages.agentSetting.button.reset': 'Reset',
  'pages.agentSetting.button.save': 'Save',
  'pages.agentSetting.save.success': 'Save successful',
  'pages.agentSetting.save.error': 'Save failed',
  'pages.agentSetting.save.missingId': 'Missing agent id, unable to save',
  'pages.agentSetting.load.tts.error': 'Failed to load TTS voices',
  'pages.agentSetting.speed.slow': 'Slow',
  'pages.agentSetting.speed.normal': 'Normal',
  'pages.agentSetting.speed.fast': 'Fast',
  'pages.agentSetting.speed.patient': 'Patient',
  'pages.agentSetting.language.chinese': 'Chinese',
  'pages.agentSetting.language.english': 'English',
  'pages.agentSetting.language.spanish': 'Spanish',
  'pages.agentSetting.language.french': 'French',
  'pages.agentSetting.language.german': 'German',
  'pages.agentSetting.language.japanese': 'Japanese',
  'pages.agentSetting.language.korean': 'Korean',
  'pages.agentSetting.language.portuguese': 'Portuguese',
  'pages.agentSetting.language.arabic': 'Arabic',
  'pages.agentSetting.language.russian': 'Russian',
  'pages.agentSetting.language.italian': 'Italian',
  'pages.agentSetting.language.turkish': 'Turkish',
  'pages.agentSetting.language.polish': 'Polish',
  'pages.agentSetting.language.catalan': 'Catalan',

  // DeviceManagement page related text
  'pages.devices.title': 'Manage Devices',
  'pages.devices.breadcrumb.agents': 'Agents',
  'pages.devices.breadcrumb.devices': 'Manage Devices',
  'pages.devices.button.addDevice': 'Add Device',
  'pages.devices.warning.noAgentId': 'No agentId specified, unable to get device list',
  'pages.devices.device.unnamed': 'Unnamed Device',
  'pages.devices.device.macAddress': 'Mac Address',
  'pages.devices.device.lastActive': 'Last Active',
  'pages.devices.device.firmwareVersion': 'Firmware Version',
  'pages.devices.device.otaUpgrade': 'OTA Upgrade',
  'pages.devices.device.noData': 'No Data',
  'pages.devices.copy.success': 'MAC address copied',
  'pages.devices.unbind.title': 'Confirm Unbind Device',
  'pages.devices.unbind.content': 'Device unbinding cannot be recovered. If you need to use it again, you need to rebind it. Are you sure to unbind?',
  'pages.devices.unbind.confirm': 'Confirm Unbind',
  'pages.devices.unbind.cancel': 'Cancel',
  'pages.devices.unbind.success': 'Device unbound',
  'pages.devices.unbind.error': 'Unbind failed',
  'pages.devices.ota.enabled': 'OTA upgrade enabled',
  'pages.devices.ota.disabled': 'OTA upgrade disabled',

  // HistoryDialogs page related text
  'pages.historyDialogs.title': 'History Dialogs',
  'pages.historyDialogs.breadcrumb.agents': 'Agents',
  'pages.historyDialogs.breadcrumb.historyDialogs': 'History Dialogs',
  'pages.historyDialogs.empty.title': 'No conversation selected',
  'pages.historyDialogs.empty.description': 'Please select a conversation',
  'pages.historyDialogs.agent': 'Agent',
  'pages.historyDialogs.agent.id': 'id',
  'pages.historyDialogs.conversationDetail': 'Conversation Details',
  'pages.historyDialogs.selectConversation': 'Please select a conversation',
  'pages.historyDialogs.delete.title': 'Delete Conversation',
  'pages.historyDialogs.delete.content': 'The conversation cannot be recovered after deletion. Please confirm the operation.',
  'pages.historyDialogs.delete.confirm': 'Confirm',
  'pages.historyDialogs.delete.cancel': 'Cancel',
  'pages.historyDialogs.message.delete.confirm': 'Are you sure you want to delete this message? It cannot be recovered after deletion.',
  'pages.historyDialogs.detail.title': 'Conversation Details',
  'pages.historyDialogs.agent.label': 'Agent:',
  'pages.historyDialogs.user.label': 'User:',
  'pages.historyDialogs.loading': 'Loading...',
  'pages.historyDialogs.error.loadFailed': 'Failed to load conversation list',
  'pages.historyDialogs.error.deleteFailed': 'Failed to delete conversation',
  'pages.historyDialogs.success.deleteSuccess': 'Conversation deleted successfully',

  // MessageList page related text
  'pages.messageList.empty': 'No messages',
  'pages.messageList.user': 'User',
  'pages.messageList.ai': 'AI',

  // Settings page related text
  'pages.settings.basicInfo.title': 'Basic Information',
  'pages.settings.avatar.label': 'Avatar:',
  'pages.settings.avatar.change': 'Change Avatar',
  'pages.settings.avatar.updateSuccess': 'Avatar updated successfully',
  'pages.settings.avatar.updateFailed': 'Failed to update avatar',
  'pages.settings.username.label': 'Username:',
  'pages.settings.nickname.label': 'Nickname:',
  'pages.settings.nickname.change': 'Edit Nickname',
  'pages.settings.nickname.modal.title': 'Edit Nickname',
  'pages.settings.nickname.form.label': 'New Nickname',
  'pages.settings.nickname.form.required': 'Please enter new nickname',
  'pages.settings.nickname.form.length': 'Nickname length should be 2-20 characters',
  'pages.settings.nickname.updateSuccess': 'Nickname updated successfully',
  'pages.settings.nickname.updateFailed': 'Failed to update nickname',
  'pages.settings.registerTime.label': 'Registration Time:',
  'pages.settings.email.label': 'Email:',
  'pages.settings.email.unbind': 'Not bound',
  'pages.settings.email.bind': 'Bind Email',
  'pages.settings.email.change': 'Change Email',
  'pages.settings.email.modal.title': 'Bind Email',
  'pages.settings.email.modal.changeTitle': 'Change Email',
  'pages.settings.email.form.label': 'Email',
  'pages.settings.email.form.required': 'Please enter email',
  'pages.settings.email.form.invalid': 'Invalid email format',
  'pages.settings.email.bindSuccess': 'Email bound successfully',
  'pages.settings.email.bindFailed': 'Failed to bind email',
  'pages.settings.changePassword.title': 'Change Password',
  'pages.settings.changePassword.button': 'Change Password',
  'pages.settings.changePassword.modal.title': 'Change Password',
  'pages.settings.changePassword.oldPassword.label': 'Old Password',
  'pages.settings.changePassword.oldPassword.required': 'Please enter old password',
  'pages.settings.changePassword.newPassword.label': 'New Password',
  'pages.settings.changePassword.newPassword.required': 'Please enter new password',
  'pages.settings.changePassword.newPassword.min': 'New password must be at least 6 characters',
  'pages.settings.changePassword.confirmPassword.label': 'Confirm New Password',
  'pages.settings.changePassword.confirmPassword.required': 'Please confirm new password',
  'pages.settings.changePassword.confirmPassword.mismatch': 'Passwords do not match',
  'pages.settings.changePassword.success': 'Password changed successfully',
  'pages.settings.changePassword.failed': 'Failed to change password',
  'pages.settings.deleteAccount.title': 'Delete Account',
  'pages.settings.deleteAccount.button': 'Delete Account',
  'pages.settings.deleteAccount.confirm.title': 'Confirm Account Deletion?',
  'pages.settings.deleteAccount.confirm.content': 'This operation cannot be undone. Are you sure you want to delete your account?',
  'pages.settings.deleteAccount.confirm.ok': 'Delete',
  'pages.settings.deleteAccount.confirm.cancel': 'Cancel',
  'pages.settings.deleteAccount.success': 'Account deleted successfully',
  'pages.settings.deleteAccount.failed': 'Failed to delete account',
  'pages.settings.profile.fetchFailed': 'Failed to fetch user information',
  'pages.settings.form.submit': 'Submit',
  'pages.settings.password.title': 'Password Settings',
  'pages.settings.basicInfo.username': 'Username',
  'pages.settings.basicInfo.nickname': 'Nickname',
  'pages.settings.basicInfo.avatar': 'Avatar',
  'pages.settings.basicInfo.editNickname': 'Edit Nickname',
  'pages.settings.basicInfo.editNicknameTitle': 'Edit Title',
  'pages.settings.basicInfo.newNicknameLabel': 'New Nickname',
  'pages.settings.basicInfo.nicknameChangeSuccess': 'Nickname changed successfully',
  'pages.settings.basicInfo.openId': 'OpenID:',
  'pages.settings.submit': 'Submit',
  'pages.settings.deleteAccount.confirmTitle': 'Confirm Account Deletion',
  'pages.settings.deleteAccount.confirmContent': 'After your account is deleted, all your data will be permanently deleted and cannot be recovered, and you will no longer be able to log in. Please proceed with caution.',
  'pages.settings.deleteAccount.cancel': 'Cancel',
  'pages.settings.deleteAccount.confirm': 'Confirm Deletion',

  // Admin Dashboard
  'pages.admin.dashboard.userCount': 'User Count',
  'pages.admin.dashboard.deviceCount': 'Device Count',
  'pages.admin.dashboard.agentCount': 'Agent Count',
  'pages.admin.dashboard.onlineUsers': 'Online Users',
  'pages.admin.dashboard.sessionDevices': 'Session Devices',
  'pages.admin.dashboard.memoryUsage': 'Memory Usage',
  'pages.admin.dashboard.cpuUsage': 'CPU Usage',
  'pages.admin.dashboard.fetchError': 'Failed to fetch data',
  'pages.admin.dashboard.networkError': 'Network Error',

  // Admin User Management
  'pages.admin.user.id': 'ID',
  'pages.admin.user.username': 'Username',
  'pages.admin.user.email': 'Email',
  'pages.admin.user.status': 'Status',
  'pages.admin.user.status.all': 'All',
  'pages.admin.user.status.disabled': 'Disabled',
  'pages.admin.user.status.normal': 'Normal',
  'pages.admin.user.quotaUsed': 'Daily Quota Used',
  'pages.admin.user.quotaTotal': 'Daily Quota Total',
  'pages.admin.user.createdAt': 'Created At',
  'pages.admin.user.operations': 'Operations',
  'pages.admin.user.edit': 'Edit',
  'pages.admin.user.detail': 'Detail',
  'pages.admin.user.editModal.title': 'Edit User',
  'pages.admin.user.status.label': 'User Status',
  'pages.admin.user.status.enable': 'Enable',
  'pages.admin.user.status.disable': 'Disable',
  'pages.admin.user.quotaUsed.label': 'Daily Quota Used',
  'pages.admin.user.quotaTotal.label': 'Daily Quota Total',
  'pages.admin.user.email.label': 'Email',
  'pages.admin.user.save.success': 'Save successful',
  'pages.admin.user.save.failed': 'Save failed',
  'pages.admin.user.list.title': 'User List',

  // Admin Model Providers
  'pages.admin.providers.title': 'Model Provider Management',
  'pages.admin.providers.total': 'Total {total} providers',
  'pages.admin.providers.stats': 'ASR: {asr}, TTS: {tts}, LLM: {llm}, VLLLM: {vlllm}',
  'pages.admin.providers.addNew': 'Add New Provider',
  'pages.admin.providers.search.placeholder': 'Search provider name, endpoint or model...',
  'pages.admin.providers.filter.all': 'All Types',
  'pages.admin.providers.filter.asr': 'ASR - Speech Recognition',
  'pages.admin.providers.filter.tts': 'TTS - Text to Speech',
  'pages.admin.providers.filter.llm': 'LLM - Large Language Model',
  'pages.admin.providers.filter.vlllm': 'VLLLM - Vision Language Model',
  'pages.admin.providers.empty.noProviders': 'No providers yet',
  'pages.admin.providers.empty.noMatches': 'No matching providers found',
  'pages.admin.providers.empty.addFirst': 'Click the button above to add your first model provider',
  'pages.admin.providers.empty.adjustFilters': 'Try adjusting search criteria or filters',
  'pages.admin.providers.type.asr': 'ASR - Speech Recognition',
  'pages.admin.providers.type.tts': 'TTS - Text to Speech',
  'pages.admin.providers.type.llm': 'LLM - Large Language Model',
  'pages.admin.providers.type.vlllm': 'VLLLM - Vision Language Model',
  'pages.admin.providers.success.created': 'Provider added successfully!',
  'pages.admin.providers.success.updated': 'Provider updated successfully!',
  'pages.admin.providers.success.deleted': 'Provider deleted successfully!',
  'pages.admin.providers.success.statusToggled': 'Status toggled successfully!',
  'pages.admin.providers.error.createFailed': 'Failed to add provider, please try again',
  'pages.admin.providers.error.updateFailed': 'Failed to update provider, please try again',
  'pages.admin.providers.error.deleteFailed': 'Failed to delete provider, please try again',
  'pages.admin.providers.error.testFailed': 'Connection test failed, please check network or configuration',
  'pages.admin.providers.error.toggleFailed': 'Failed to toggle status, please try again',
  'pages.admin.providers.error.loadFailed': 'Failed to load provider list, please refresh the page',

  // Admin Settings
  'pages.admin.settings.title': 'System Settings',
  'pages.admin.settings.asr.label': 'ASR Service',
  'pages.admin.settings.asr.placeholder': 'Select ASR Service',
  'pages.admin.settings.tts.label': 'TTS Service',
  'pages.admin.settings.tts.placeholder': 'Select TTS Service',
  'pages.admin.settings.llm.label': 'LLM Service',
  'pages.admin.settings.llm.placeholder': 'Select LLM Service',
  'pages.admin.settings.vlllm.label': 'VLLLM Service',
  'pages.admin.settings.vlllm.placeholder': 'Select VLLLM Service',
  'pages.admin.settings.prompt.label': 'Prompt Settings',
  'pages.admin.settings.prompt.placeholder': 'Please enter system prompt...',
  'pages.admin.settings.quickReply.label': 'Quick Reply Words',
  'pages.admin.settings.quickReply.placeholder': 'Enter new quick reply word',
  'pages.admin.settings.quickReply.add': 'Add',
  'pages.admin.settings.deleteAudio.label': 'Delete Audio',
  'pages.admin.settings.deleteAudio.enabled': 'Enabled',
  'pages.admin.settings.deleteAudio.disabled': 'Disabled',
  'pages.admin.settings.usePrivateConfig': 'Use Private Config',
  'pages.admin.settings.save': 'Save Configuration',
  'pages.admin.settings.saving': 'Saving...',
  'pages.admin.settings.reset': 'Reset',
  'pages.admin.settings.success.saved': 'Configuration saved successfully!',
  'pages.admin.settings.error.saveFailed': 'Failed to save configuration, please try again',
  'pages.admin.settings.error.loadFailed': 'Failed to load configuration, please refresh the page and try again',

  // Add Device Dialog
  'pages.addDevice.modal.title': 'Add Device',
  'pages.addDevice.verificationCode.label': 'Verification Code:',
  'pages.addDevice.verificationCode.placeholder': 'Please enter the 6-digit verification code from device',
  'pages.addDevice.verificationCode.required': 'Please enter a 6-digit verification code',
  'pages.addDevice.verificationCode.error': 'Please enter a 6-digit verification code',

  // Provider Modal
  'pages.admin.providerModal.edit.title': 'Edit Provider',
  'pages.admin.providerModal.add.title': 'Add New Provider',
  'pages.admin.providerModal.name.label': 'Provider Name *',
  'pages.admin.providerModal.name.placeholder': 'e.g.: OpenAI, Doubao TTS',
  'pages.admin.providerModal.name.required': 'Please enter provider name',
  'pages.admin.providerModal.type.label': 'Service Category *',
  'pages.admin.providerModal.subType.label': 'Specific Type *',
  'pages.admin.providerModal.subType.required': 'Please select specific type',
  'pages.admin.providerModal.config.title': 'Configuration',
  'pages.admin.providerModal.api.url.label': 'API URL *',
  'pages.admin.providerModal.api.url.required': 'Please enter API URL',
  'pages.admin.providerModal.model.name.label': 'Model Name *',
  'pages.admin.providerModal.model.name.required': 'Please enter model name',
  'pages.admin.providerModal.model.label': 'Model *',
  'pages.admin.providerModal.model.required': 'Please enter model',
  'pages.admin.providerModal.api.key.label': 'API Key *',
  'pages.admin.providerModal.api.key.required': 'Please enter API key',
  'pages.admin.providerModal.temperature.label': 'Temperature (0-2)',
  'pages.admin.providerModal.temperature.error': 'Temperature should be between 0-2',
  'pages.admin.providerModal.maxTokens.label': 'Max Tokens',
  'pages.admin.providerModal.maxTokens.error': 'Max tokens should be between 1-32768',
  'pages.admin.providerModal.topP.label': 'Top-P',
  'pages.admin.providerModal.appid.label': 'App ID *',
  'pages.admin.providerModal.appid.required': 'Please enter App ID',
  'pages.admin.providerModal.accessToken.label': 'Access Token *',
  'pages.admin.providerModal.accessToken.required': 'Please enter access token',
  'pages.admin.providerModal.cluster.label': 'Cluster',
  'pages.admin.providerModal.grpc.host.label': 'gRPC Host *',
  'pages.admin.providerModal.grpc.host.required': 'Please enter gRPC host address',
  'pages.admin.providerModal.grpc.port.label': 'gRPC Port *',
  'pages.admin.providerModal.grpc.port.required': 'Please enter gRPC port',
  'pages.admin.providerModal.grpc.addr.label': 'gRPC Address (host:port) *',
  'pages.admin.providerModal.grpc.addr.required': 'Please enter gRPC address (host:port)',
  'pages.admin.providerModal.voice.label': 'Voice *',
  'pages.admin.providerModal.voice.required': 'Please enter voice type',
  'pages.admin.providerModal.token.label': 'Token *',
  'pages.admin.providerModal.token.required': 'Please enter token',
  'pages.admin.providerModal.websocket.label': 'WebSocket URL *',
  'pages.admin.providerModal.websocket.required': 'Please enter WebSocket URL',
  'pages.admin.providerModal.siliconflow.apiKey.label': 'API Key *',
  'pages.admin.providerModal.siliconflow.apiKey.required': 'Please enter API key',
  'pages.admin.providerModal.siliconflow.baseUrl.label': 'API URL',
  'pages.admin.providerModal.outputDir.label': 'Output Directory',
  'pages.admin.providerModal.manage.voices': 'Manage Voices',
  'pages.admin.providerModal.edge.noConfig': 'Microsoft Edge TTS requires no additional configuration',
  'pages.admin.providerModal.submit.error': 'Submit failed, please try again',
  'pages.admin.providerModal.copyAsNew': 'Copy as New Provider',

  // Provider Card
  'pages.admin.providerCard.status.active': 'Active',
  'pages.admin.providerCard.status.inactive': 'Offline',
  'pages.admin.providerCard.status.error': 'Error',
  'pages.admin.providerCard.status.unknown': 'Unknown',
  'pages.admin.providerCard.warning.readonly.test': 'Read-only permission, cannot test provider',
  'pages.admin.providerCard.warning.readonly.delete': 'Read-only permission, cannot delete provider',
  'pages.admin.providerCard.warning.readonly.edit': 'Read-only permission, cannot edit provider',
  'pages.admin.providerCard.warning.readonly.toggle': 'Read-only permission, cannot toggle status',
  'pages.admin.providerCard.button.disable': 'Disable',
  'pages.admin.providerCard.button.enable': 'Enable',
  'pages.admin.providerCard.button.testing': 'Testing...',
  'pages.admin.providerCard.button.test': 'Test',
  'pages.admin.providerCard.button.edit': 'Edit',
  'pages.admin.providerCard.button.delete': 'Delete',
  'pages.admin.providerCard.delete.title': 'Are you sure you want to delete this item?',
  'pages.admin.providerCard.delete.content': 'It cannot be recovered after deletion, please confirm the operation.',
  'pages.admin.providerCard.config.type': 'Type',
  'pages.admin.providerCard.config.apiUrl': 'API URL',
  'pages.admin.providerCard.config.model': 'Model',
  'pages.admin.providerCard.config.apiKey': 'API Key',
  'pages.admin.providerCard.config.temperature': 'Temperature',
  'pages.admin.providerCard.config.maxTokens': 'Max Tokens',
  'pages.admin.providerCard.config.appid': 'App ID',
  'pages.admin.providerCard.config.cluster': 'Cluster',
  'pages.admin.providerCard.config.accessToken': 'Access Token',
  'pages.admin.providerCard.config.grpcHost': 'gRPC Host',
  'pages.admin.providerCard.config.grpcPort': 'gRPC Port',
  'pages.admin.providerCard.config.voice': 'Voice',
  'pages.admin.providerCard.config.format': 'Format',
  'pages.admin.providerCard.config.token': 'Token',
  'pages.admin.providerCard.config.outputDir': 'Output Directory',
  'pages.admin.providerCard.voices.supported': 'Supported Voices',
  'pages.admin.providerCard.voices.count': '',
  'pages.admin.providerCard.test.failed': 'Test failed',

  // OpsManage
  'pages.admin.ops.service.title': 'Service Management',
  'pages.admin.ops.upload.button': 'Upload Service File',
  'pages.admin.ops.upload.success': 'Service file uploaded successfully',
  'pages.admin.ops.upload.error': 'Service file upload failed',
  'pages.admin.ops.restart.button': 'Restart Service',
  'pages.admin.ops.restart.confirmTitle': 'Caution: Are you sure you want to restart the service?',
  'pages.admin.ops.restart.desc': 'Restarting the service will disconnect all current connections and make the service temporarily unavailable.',
  'pages.admin.ops.restart.warn': 'This operation will only stop the current service process. Please ensure a daemon or auto-restart script is configured on the server, otherwise the service will not recover automatically!',
  'pages.admin.ops.restart.ok': 'Confirm Restart',
  'pages.admin.ops.restart.cancel': 'Cancel',
  'pages.admin.ops.restart.success': 'Service restart command sent',
  'pages.admin.ops.restart.error': 'Service restart failed',
  'pages.admin.ops.log.title': 'Log View & Download',
  'pages.admin.ops.web.upload.button': 'Upload web.zip',
  'pages.admin.ops.web.upload.success': 'web.zip uploaded successfully',
  'pages.admin.ops.web.upload.error': 'web.zip upload failed',
  'pages.admin.ops.web.upload.onlyzip': 'Only zip files are allowed',
  'pages.admin.ops.web.update.button': 'Update web directory',
  'pages.admin.ops.web.update.success': 'Web directory update command sent',
  'pages.admin.ops.web.update.error': 'Web directory update failed',
  'pages.admin.ops.web.upload.onlywebzip': 'Only a file named web.zip is allowed',

  // Recorder Management
  'pages.admin.recorder.title': 'Device Recorder Management',
  'pages.admin.settings.voiceCloneEnable': 'Enable Voice Clone',
  'pages.admin.recorder.inputDeviceId': 'Please enter device ID',
  'pages.admin.recorder.inputPlaceholder': 'Please enter device ID',
  'pages.admin.recorder.search': 'Search',
  'pages.admin.recorder.list.title': 'Recorder List',
  'pages.admin.recorder.fetchSuccess': 'Successfully retrieved recorder records',
  'pages.admin.recorder.fetchError': 'Failed to retrieve recorder list',
  'pages.admin.recorder.empty': 'No recorder data, please enter device ID to search',
  'pages.admin.recorder.totalCount': 'Statistics',
  'pages.admin.recorder.conversationId': 'Conversation ID',

  //contractDevice
  'pages.contractDevice.cardTitle': 'Contract Device Management',
  'pages.contractDevice.mac': 'MAC Address',
  'pages.contractDevice.protocolType': 'Protocol Type',
  'pages.contractDevice.status': 'Status',
  'pages.contractDevice.expireTime': 'Expiration Time',
  'pages.contractDevice.updateTime': 'Update Time',
  'pages.contractDevice.operations': 'Actions',
  'pages.contractDevice.edit': 'Edit',
  'pages.contractDevice.delete': 'Delete',
  'pages.contractDevice.deleteConfirm': 'Confirm Delete',
  'pages.contractDevice.addTitle': 'Add Contract Device',
  'pages.contractDevice.batchAddTitle': 'Batch Add',
  'pages.contractDevice.editTitle': 'Edit Contract Device',
  'pages.contractDevice.listTitle': 'Contract Device List',
  'pages.contractDevice.add': 'Add',
  'pages.contractDevice.batchAdd': 'Batch Add',
  'pages.contractDevice.selectCsvTip': 'Please select a CSV file',
  'pages.contractDevice.uploadSuccess': 'Upload successful',
  'pages.contractDevice.macRequired': 'Please enter MAC address',
  'pages.contractDevice.protocolTypeRequired': 'Please select protocol type',
  'pages.contractDevice.statusRequired': 'Please select status',
  'pages.contractDevice.expireTimeRequired': 'Please select expiration time',

  'pages.agentSetting.mcp.modal.title': 'MCP Endpoint Settings',
  'pages.agentSetting.mcp.modal.statusLabel': 'Endpoint Status',
  'pages.agentSetting.mcp.modal.online': 'Online',
  'pages.agentSetting.mcp.modal.disconnected': 'Disconnected',
  'pages.agentSetting.mcp.modal.unknown': 'Unknown',
  'pages.agentSetting.mcp.modal.refresh': 'Refresh',
  'pages.agentSetting.mcp.modal.enabledServices': 'Enabled Services',
  'pages.agentSetting.mcp.modal.endpointLabel': 'Endpoint Address',
  'pages.agentSetting.mcp.modal.endpointDesc': 'Below is the MCP endpoint address for the agent.',
  'pages.agentSetting.mcp.modal.docLink': 'View Endpoint Documentation',
  'pages.agentSetting.mcp.modal.noEndpoint': 'No available endpoint',
  'pages.agentSetting.mcp.modal.hide': 'Hide',
  'pages.agentSetting.mcp.title': 'MCP Settings',
  'pages.agentSetting.mcp.customService': 'Custom Service',
  'pages.agentSetting.mcp.officialServices': 'Official Services',
  'pages.agentSetting.mcp.officialServices.placeholder': 'Select official services',
  'pages.agentSetting.mcp.services.weather': 'Weather',
  'pages.agentSetting.mcp.services.joke': 'Joke',
  'pages.agentSetting.mcp.services.music': 'Music',
  'pages.agentSetting.mcp.services.news': 'News',
  'pages.agentSetting.mcp.error.missingId': 'Missing agent id, cannot retrieve endpoint',
  'pages.agentSetting.mcp.error.noEndpoint': 'Failed to retrieve endpoint from server',
'pages.agentSetting.mcp.error.fetchFailed': 'Failed to retrieve endpoint',
  'pages.agentSetting.mcp.button.getEndpoint': 'Get MCP Endpoint',

  // Memory settings
  'pages.agentSetting.memory.title': 'Short-term Memory',
  'pages.agentSetting.memory.type.label': 'Memory Type',
  'pages.agentSetting.memory.type.none': 'No Memory',
  'pages.agentSetting.memory.type.shortTerm': 'Short-term Memory',
  'pages.agentSetting.memory.current.label.short': 'Current Memory',
  'pages.agentSetting.memory.current.help': 'Regenerated after each conversation',
  'pages.agentSetting.memory.clear': 'Clear Memory',
  'pages.agentSetting.memory.clear.tip': 'Memory marked for clearing, click save to apply',
  'pages.agentSetting.memory.content.label': 'Memory Content',
  'pages.agentSetting.memory.content.placeholder': 'Get latest short-term memory content',
  'pages.agentSetting.memory.content.editPlaceholder': 'Please enter memory content',
  'pages.agentSetting.memory.edit': 'Edit Memory',
  'pages.agentSetting.memory.edit.success': 'Memory updated, please save to apply',
  'pages.agentSetting.memory.edit.save': 'Save Changes',
  'pages.agentSetting.memory.edit.cancel': 'Cancel',

  // Common buttons and actions
  'pages.common.cancel': 'Cancel',

  // System Configuration
  'pages.admin.systemConfig.roleName': 'Role Name',
  'pages.admin.systemConfig.roleDesc': 'Role Description',
  'pages.admin.systemConfig.enabled': 'Enabled Status',
  'pages.admin.systemConfig.featureName': 'Feature Name',
  'pages.admin.systemConfig.featureDesc': 'Feature Description',
  'pages.admin.systemConfig.exitCommand': 'Exit Command',
  'pages.admin.systemConfig.mcpName': 'MCP Name',
  'pages.admin.systemConfig.newNameOptional': 'New Name (Optional)',
  'pages.admin.systemConfig.configJson': 'Config JSON',
  'pages.admin.systemConfig.useDeviceCode': 'Use Device Code',
  'pages.admin.systemConfig.quickReply': 'Quick Reply',
  'pages.admin.systemConfig.shortTermMemory': 'Short Term Memory',
  'pages.admin.systemConfig.saveUserAudio': 'Save User Audio Files',
  'pages.admin.systemConfig.enableWhiteList': 'Enable White List',
  'pages.admin.systemConfig.enhancedEmotionOutput': 'Enhanced Emotion Output',
  'pages.admin.systemConfig.speakerDetect': 'Speaker Recognition',
  'pages.admin.systemConfig.recorderManagerEnable': 'Enable Recorder Management',
  'pages.admin.systemConfig.voiceCloneEnable': 'Enable Voice Clone',
  'pages.admin.systemConfig.flattenedChatHistory': 'Flattened Chat History',
  'pages.admin.systemConfig.dialogueHistoryLength': 'Dialogue History Length',
  'pages.admin.systemConfig.userTotalQuota': 'User Total Quota',
  'pages.admin.systemConfig.dailyClearQuota': 'Daily Clear Quota',
  'pages.admin.systemConfig.checkDeviceModeImmediately': 'Check Device Mode Immediately',
  'pages.admin.systemConfig.defaultObserverUserOnRegister': 'Default Observer User on Register',
  'pages.admin.systemConfig.status': 'Status',
  'pages.admin.systemConfig.port': 'Port',
  'pages.admin.systemConfig.udpShowPort': 'Show Port',
  'pages.admin.systemConfig.accessToken': 'Access Token',
  'pages.admin.systemConfig.activateText': 'Activate Text',
  'pages.admin.systemConfig.logLevel': 'Log Level',
  'pages.admin.systemConfig.logDir': 'Log Directory',
  'pages.admin.systemConfig.logFileName': 'Log File Name',

  // Voice Clone
  'pages.console.voiceClone.name': 'Name',
  'pages.console.voiceClone.provider': 'Provider',
  'pages.console.voiceClone.mode': 'Mode',
  'pages.console.voiceClone.record': 'Record',
  'pages.console.voiceClone.upload': 'Upload',

  // Speakers
  'pages.console.speakers.name': 'Name',
  'pages.console.speakers.mode': 'Mode',
  'pages.console.speakers.record': 'Record',
  'pages.console.speakers.upload': 'Upload',

  // Settings
  'pages.console.settings.email': 'Email',
  'pages.console.settings.oldPassword': 'Old Password',
  'pages.console.settings.newPassword': 'New Password',
  'pages.console.settings.confirmNewPassword': 'Confirm New Password',

  // VLLM Provider
  'pages.providers.vllm.maxPixels': 'Max Pixels',

  'pages.unbindDevice.cardTitle': 'Unbind Device',
  'pages.whiteList.cardTitle': 'Whitelist Management',
  'pages.admin.devices': 'Device Management',
  'pages.admin.unbindDevice': 'Unbind Device',
  'pages.admin.deviceManage': 'Device Management',
  'pages.systemConfig.quickReply': 'Quick Reply',
  'pages.systemConfig.useShortTermMemory': 'Short Term Memory',
  'pages.systemConfig.useShortTermMemory.desc': 'When enabled, the system uses short-term memory mechanism to update short-term memory after each round of dialogue. When disabled, short-term memory is not used.',
  'pages.agentSetting.mcp.modal.show': 'Show',
  'pages.agentSetting.mcp.modal.copied': 'Copied',
  'pages.agentSetting.mcp.modal.copy': 'Copy',
  'pages.admin.providerModal.model.placeholder': 'Please enter model name',
  'pages.admin.providerModal.security.title': 'Security Settings',
  'pages.admin.providerModal.appid.placeholder': 'Doubao App ID',
  'pages.admin.providerModal.accessToken.placeholder': 'Access Token',
  'pages.admin.providerModal.token.placeholder': 'Doubao Token',
  'pages.admin.providerModal.siliconflow.apiKey.placeholder': 'API Key',
  'pages.admin.providerModal.manageVoices': 'Manage Voices',
  'pages.admin.whiteList.inputMac': 'Please enter MAC address',
  'pages.admin.whiteList.batchAdd': 'Batch Add',
  'pages.admin.whiteList.add': 'Add',
  'pages.admin.whiteList.list.title': 'MAC Address List',
  'pages.admin.whiteList.selectCsvTip': 'Please select a CSV file',
  'pages.admin.whiteList.uploadSuccess': 'Upload Success',
  'pages.admin.whiteList.uploadFailed': 'Upload Failed',
  'pages.admin.whiteList.invalidMac': 'Please enter a valid MAC address',
  'pages.agentSetting.roleTemplate.empty': 'No template available, please check role_template.json',
  'pages.admin.providerModal.save': 'Save',
};